import {
  BackdropCircularProgress,
  EnhancedSnackbar,
  FlatStandardPanel,
  ITest,
  SingleColumnLayout,
  Spacer,
} from "@websential/cosmic";
import {
  Box,
  Button,
  Divider,
  Grid,
  InputLabel,
  Paper,
  Typography,
} from "@mui/material";
import {
  CompanyDetailPanel,
  DifferencePanel,
  RL16SlipDetailPanel,
  TotalBalancePanel,
} from "./Panels";
import {
  EnhancedDialog,
  EnhancedLinkButton,
  IconTextButton,
  RouterLinkButton,
  SplitButton,
} from "@websential/cosmic";
import {
  EnhancedDivider,
  EnhancedDropDownRHF,
  EnhancedDropDownRHFWithLabel,
  EnhancedTextAreaFieldRHF,
  LabelPosition,
  RHookFormTextField,
  RequiredAsterisk,
} from "@websential/cosmic";
import { FC, useEffect, useMemo, useState } from "react";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import {
  GET_QUERY_KEY,
  INITIAL_SNACKBAR_DATA,
  QUERY_OPTIONS,
  RL16_SUMMARY_SCREEN_SLUG,
} from "../../../common/constants";
import { IResponse, IServerError } from "../../../models/common";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AdjustmentOptionsService } from "../../../services/AdjustmentOptionsService";
import { ClientService } from "../../../services";
import FileSaver from "file-saver";
import { FlexFieldService } from "../../../services/FlexFieldService";
import { IAppState } from "../../../store/reducers";
import { IFlexFieldSetupRequest } from "../../../models/flexField/IFlexFieldSetupRequest";
import { InvoiceDialogPanel } from "../../../components/T4Slip/T4SlipList/InvoiceDialogPanel";
import { PrintingService } from "../../../services/PrintingService";
import { RL16SlipService } from "../../../services/RL16SlipService";
import { RL16SummarySetupSchema } from "./rl16SummaryValidation";
import { RL16SummaryToolbar } from "../RL16SummaryToolbar";
import { ReportsService } from "../../../services/ReportsService";
import { T4SlipService } from "../../../services/T4SlipService";
import { T4SummarySetupSchema } from "../../../components/T4Slip/T4SlipSummarySetup/summaryValidate";
import { TaxSlipAccountInformation } from "../../../components/TaxSlipAccountInformation";
import { TaxSlipFilingResourceSelectionPanel } from "../../../components/TaxSlipFilingResource";
import { TaxSlipSettingsService } from "../../../services/TaxSlipSettingsService";
import { TaxSlipSummaryDataInput } from "../../../components/TaxSlipSummaryDataInput";
import { checkSummaryType } from "../../../components/T4Slip";
import { getValidationSchema } from "./validator";
import { instanceOfIFlexFieldSetupRequest } from "../../../common/instance-method";
import { setSelectedActivityLogActions } from "../../../store/actions/activityLogActions";
import { setSelectedDashboardApisData } from "../../../store/actions/dashboardApisDataActions";
import { setSelectedINVOICE } from "../../../store/actions";
import { setSelectedStickyNavBar } from "../../../store/actions/stickyNavBarActions";
import { yupResolver } from "@hookform/resolvers/yup";

// import { Divider, Paper } from "@mui/material";

























export let selectedRL16SummaryType: any = 400;
export interface IRL16SlipSummarySetup extends ITest { }

const DEFAULT_VALUES = {
  // comparison: [
  //   {
  //     operator: undefined,
  //     field: undefined,
  //   },
  // ],
  // fieldType: undefined,
  // fieldLabel: "",
  // fieldId: "",
  // defaultValue: "",
  // placeholder: "",
  // fieldFormat: "",
  // fieldValue: "",
  // dataType: undefined,
  // fieldColumn: undefined,
  // parentRelation: undefined,
  // fieldInternalValue: "",
  // notes: "",
  // minValue: 0,
  // maxValue: 0,
  // isCategory: false,
  // isFixed: false,
  // isHide: false,
  // isRequired: false,
  // parentValue: "",
  // parent: undefined,
  // id: undefined,
};

const RL16_SUMMARY_DATA_QUERY_KEY = "get-rl16-summary-data";
// const LIST_RL16_SUMMARY_QUERY_KEY = "get-RL16-summary-list";
// const RL16_SUMMARY_DATA_QUERY_KEY = "get-t4-summary-data";

const useGetRL16SummaryData = (
  clientid: string,
  slipType: string | number,
  taxYear: number
) =>
  useQuery({
    queryKey: [RL16_SUMMARY_DATA_QUERY_KEY, clientid, slipType, taxYear],
    queryFn: (data) => {
      return RL16SlipService.getRL16Summary(clientid, slipType, taxYear);
    },
    refetchOnWindowFocus: false
  });

const useGetGlobalVariables = (taxYear: number) =>
  useQuery({
    queryKey: [GET_QUERY_KEY.GET_GLOBAL_VARIABLES_BY_YEAR, taxYear],
    queryFn: (data) => {
      return TaxSlipSettingsService.getGlobalVariables(taxYear);
    },
    refetchOnWindowFocus: false
  });

const useGetSlipIds = (
  tag: string,
  clientId: string,
  taxYear: number
) =>
  useQuery({
    queryKey: ["get-slip-ids", tag, clientId, taxYear],
    queryFn: (data) => {
      return T4SlipService.getSlipIds(tag, clientId, taxYear);
    },
    refetchOnWindowFocus: false
  });

// const useGetCompanyData = (id: string | undefined) =>
//   useQuery({
//     queryKey: ["client-get-by-id", id],
//     queryFn: (data) => {
//       return ClientService.getById(id);
//     },
//     refetchOnWindowFocus: false
//   });

export const RL16SlipSummarySetup: FC<IRL16SlipSummarySetup> = ({ testId }) => {
  const [snackbarData, setSnackbarData] = useState<any>(INITIAL_SNACKBAR_DATA);
  const queryClient = useQueryClient();
  const clientName = useSelector((state: IAppState) => state.client.clientName);
  const isLoadingActivityLogData = useSelector(
    (state: IAppState) => state.isLoadAxiosCall.isLoading
  );
  const [invoicePaymentFor, setInvoicePaymentFor] = useState(10)
  const dashboardApiData = useSelector((state: IAppState) => state.dashboardApisData);
  const dispatch = useDispatch();
  const id = useSelector((state: IAppState) => state.client.id);
  const clientId = useSelector((state: IAppState) => state.client.id);
  const taxYear = useSelector((state: IAppState) => state.taxYear.year);

  const [selectedType, setSelectedType] = useState(400);
  const [openInvoiceDialog, setInvoiceDialogOpen] = useState(false);
  const [invoiceData, setInvoiceData] = useState<any>([]);
  const [isLoadingData, setIsLoadingData] = useState(false);

  // const maskedStatus: any = sessionStorage.getItem("maskEnabled");
  const { isPending: isLoadingGlobalVariables, data: editDataRecord } =
    useGetGlobalVariables(taxYear);
  const globalVariablesData: any = editDataRecord;

  const { isPending: loadingSlipIds, data: rl16SlipIds } = useGetSlipIds("RL16", clientId, taxYear);

  // const { isPending: isLoadingClientDataById, data: companyGetByIdRecord } =
  //   useGetCompanyData(clientId);

  useEffect(() => {
    if (dashboardApiData && dashboardApiData.client_detail && dashboardApiData.client_detail.metaFields) {
      const paymentFor = dashboardApiData.client_detail.metaFields.find((item: any) => item.name === 'invoice_payment_for')
      setInvoicePaymentFor(paymentFor ? parseInt(paymentFor.value) : 10)
    }
  }, [dashboardApiData])

  const { isPending: isSubmitting, mutate: submitFormData } = useMutation({
    mutationFn: RL16SlipService.createSummary,

    onSuccess: (
      res: IFlexFieldSetupRequest | IServerError | IResponse | any
    ) => {

      if (res.status === 201 || res.status === 200) {
        setSnackbarData({
          open: true,
          message: "Data has been submitted successfully!",
          severity: "success",
        });
        queryClient.invalidateQueries({ queryKey: [RL16_SUMMARY_DATA_QUERY_KEY, res.data.id] });
        refetchSlipType();
        dispatch(setSelectedDashboardApisData({ rl16_summary: { confirmationCode: res.data.confirmationCode } }));
      } else {
        if (res) {
          setSnackbarData({
            open: true,
            message:
              res &&
                res.message !== undefined &&
                typeof (res.message && res.message) !== "object"
                ? res.message && res.message
                : res.message.message
                  ? res.message.message
                  : "Data has been submitted successfully!",
            severity:
              res.status === false
                ? "error"
                : res.success === false
                  ? "error"
                  : "success",
          });
        }
      }
    },
    onError: (err) => {

      // TODO: customize the toast message based on the response
      setSnackbarData({
        open: true,
        message: "Something went wrong, try again later!",
        severity: "error",
      });
    },
  }
  );
  const formMethods = useForm<any>({
    resolver: yupResolver(RL16SummarySetupSchema),
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: DEFAULT_VALUES,
  });

  const {
    isLoading: isLoadingSummaryGetData,
    isFetching: reFetchingSlipType,
    refetch: refetchSlipType,
    data: RL16SummaryData,
  } = useGetRL16SummaryData(id, selectedType, taxYear);


  /**
   * Handle when the form is submitted.
   *
   * @param {IFlexFieldSetupRequest} formData
   */
  const onSubmit = (formData: any) => {
    let Payload: any = {
      id: id,
      taxYear: taxYear,
      slipType: 400,
      confirmationCode:
        formData.confirmationCode !== ""
          ? formData.confirmationCode
          : undefined,
      rl16FiledOnPaper: formData.rl16FiledOnPaper,
      rl16FiledOnline: formData.rl16FiledOnline,
    };
    // submitFlexFields(formData);
    submitFormData(Payload);

  };

  const onCloseHandler = () => {
    setInvoiceDialogOpen(false);
  };

  // const saveXmlAsFile = (xmlData: any, filename: any) => {
  //   const blob = new Blob([xmlData], { type: "xml;charset=utf-8" });
  //   FileSaver.saveAs(blob, filename);
  // };
  // const onGenerateXMLClicked = async (): Promise<void> => {
  //   setIsLoadingData(true);
  //   if (maskedStatus === "true") {
  //     setIsLoadingData(false);
  //     setSnackbarData({
  //       open: true,
  //       message: "Please unmask your data.",
  //       severity: "error",
  //     });
  //   } else {
  //     try {
  //       const response: any = await ReportsService.createInvoice(
  //         clientId,
  //         taxYear
  //       );
  //       setIsLoadingData(false);
  //   
  //       if (response.message === "Slips not found for invoice.") {
  //         setIsLoadingData(true);
  //         try {
  //           const filingAuditResponse: any =
  //             await RL16SlipService.getRL16AuditFiling(clientId, taxYear);
  //          
  //           if (
  //             filingAuditResponse &&
  //             filingAuditResponse.general_filling &&
  //             filingAuditResponse.general_filling.length > 0
  //           ) {
  //             
  //           
  //             setSnackbarData({
  //               open: true,
  //               message: (
  //                 <>
  //                   Please load Audit in the menu and clear all audit items
  //                   (Audit Filing and PIER Review) to generate documents.{" "}
  //                   <a
  //                     href="https://appv3.taxslips.com/#/audit/filing"
  //                     style={{
  //                       color: "#aa1010",
  //                       textDecoration: "none",
  //                       fontWeight: "bold",
  //                     }}
  //                   >
  //                     Click here to view
  //                   </a>
  //                 </>
  //               ),
  //               severity: "error",
  //               autoHide: false,
  //             });
  //           } else if (
  //             filingAuditResponse &&
  //             filingAuditResponse.rl16_filling &&
  //             filingAuditResponse.rl16_filling.length > 0
  //           ) {
  //        
  //          
  //             setSnackbarData({
  //               open: true,
  //               message: (
  //                 <>
  //                   Please load Audit in the menu and clear all audit items
  //                   (Audit Filing and PIER Review) to generate documents.{" "}
  //                   <a
  //                     href="https://appv3.taxslips.com/#/audit/filing"
  //                     style={{
  //                       color: "#aa1010",
  //                       textDecoration: "none",
  //                       fontWeight: "bold",
  //                     }}
  //                   >
  //                     Click here to view
  //                   </a>
  //                 </>
  //               ),
  //               severity: "error",
  //               autoHide: false,
  //             });
  //           } else {
  //             setIsLoadingData(true);
  //             try {
  //               const response: any = await PrintingService.createRL16Xml(
  //                 clientId,
  //                 selectedType,
  //                 taxYear
  //               );
  //               if (response.status === 400) {
  //                 setSnackbarData({
  //                   open: true,
  //                   message: response.data.message
  //                     ? response.data.message
  //                     : "Something went wrong.",
  //                   severity: "error",
  //                 });
  //               } else {
  //                 const filename = "RL-16xml.xml";
  //                 saveXmlAsFile(response, filename);
  //               }
  //               setIsLoadingData(false);
  //             } catch (err) {
  //           
  //               alert(err);
  //             }
  //           }
  //           setIsLoadingData(false);
  //         } catch (err: any) {
  //           setIsLoadingData(false);
  //           alert(err);
  //         }
  //       } else if (response && response.id !== null) {
  //         setInvoiceData(response);
  //         setInvoiceDialogOpen(true);
  //       } else {
  //         setSnackbarData({
  //           open: true,
  //           message: "Something went wrong.",
  //           severity: "error",
  //         });
  //       }
  //       setIsLoadingData(false);
  //     } catch (err) {
  //    
  //       setIsLoadingData(false);
  //     }
  //   }
  // };
  const savePdfAsFile = (pdfData: any, filename: any) => {
    const blob = new Blob([pdfData], { type: "pdf;charset=utf-8" });
    FileSaver.saveAs(blob, filename);
  };
  const onPrintClicked = async (event: any): Promise<void> => {
    setIsLoadingData(true);
    // const maskedStatus: any = sessionStorage.getItem("maskEnabled");
    if (dashboardApiData.masked_status) {
      setIsLoadingData(false);
      setSnackbarData({
        open: true,
        message: "Please unmask your data.",
        severity: "error",
      });
    } else {
      if (invoicePaymentFor === 10) {
        try {
          const previousYearInvoiceResponse: any = await ReportsService.getPreviousYearInvoice(
            clientId,
            taxYear - 1
          );
          try {
            const response: any = await ReportsService.createInvoice(
              clientId,
              taxYear
            );
            setIsLoadingData(false);

            if (previousYearInvoiceResponse.message === "Slips not found for invoice." && response.message === "Slips not found for invoice.") {
              if (rl16SlipIds && rl16SlipIds.generalAuditStatus !== null && rl16SlipIds.generalAuditStatus === true &&
                rl16SlipIds && rl16SlipIds.auditStatus !== null && rl16SlipIds.auditStatus === true) {
                setIsLoadingData(true);
                try {
                  const response: any =
                    await PrintingService.createRL16SummaryPdfPrint(
                      clientId,
                      400,
                      taxYear,
                      event === "Print PDF (English)"
                        ? "rl16-english"
                        : "rl16-french"
                    );
                  if (response.status === 400) {
                    setSnackbarData({
                      open: true,
                      message: response.data.message
                        ? response.data.message
                        : "Something went wrong.",
                      // message: "Please Unmask sensitive data for PDF printing.",
                      severity: "error",
                    });
                  } else {
                    const filename = `RL16Summary-${clientName}-${event === "Print PDF (English)" ? "English" : "French"
                      }.pdf`;
                    savePdfAsFile(response, filename);
                  }
                  setIsLoadingData(false);
                } catch (err) {

                  alert(err);
                }
                // }
                setIsLoadingData(false);
              } else {
                setIsLoadingData(false);
                setSnackbarData({
                  open: true,
                  message: (
                    <>
                      Please load Audit in the menu, press Run RL-16 Audit and clear all audit items to generate documents.{" "}
                      <a
                        href="https://appv3.taxslips.com/#/audit/filing"
                        style={{
                          color: "#aa1010",
                          textDecoration: "none",
                          fontWeight: "bold",
                        }}
                      >
                        Click here to view
                      </a>
                    </>
                  ),
                  severity: "error",
                  autoHide: false,
                });
              }

            } else if (
              response?.id != null &&
              previousYearInvoiceResponse?.id != null
            ) {

              setInvoiceData([previousYearInvoiceResponse, response]);
              setInvoiceDialogOpen(true);
            } else if (
              previousYearInvoiceResponse?.id != null &&
              response?.message === "Slips not found for invoice."
            ) {

              setInvoiceData([previousYearInvoiceResponse]);
              setInvoiceDialogOpen(true);
            } else if (
              response?.id != null &&
              previousYearInvoiceResponse?.message === "Slips not found for invoice."
            ) {

              setInvoiceData([response]);
              setInvoiceDialogOpen(true);
            } else {
              setSnackbarData({
                open: true,
                message: "Something went wrong.",
                severity: "error",
              });
            }
            setIsLoadingData(false);
          } catch (err) {

            setIsLoadingData(false);
          }
        } catch (err) {

          setIsLoadingData(false);
        }
      } else {
        try {
          const response: any = await ReportsService.createInvoice(
            clientId,
            taxYear
          );
          setIsLoadingData(false);

          if (response.message === "Slips not found for invoice.") {
            // setIsLoadingData(true);
            // try {
            //   const filingAuditResponse: any =
            //     await RL16SlipService.getRL16AuditFiling(clientId, taxYear);

            //   if (
            //     filingAuditResponse &&
            //     filingAuditResponse.general_filling &&
            //     filingAuditResponse.general_filling.length > 0
            //   ) {
            //    ;
            //     setSnackbarData({
            //       open: true,
            //       message: (
            //         <>
            //           Please load Audit in the menu and clear all audit items
            //           (Audit Filing and PIER Review) to generate documents.{" "}
            //           <a
            //             href="https://appv3.taxslips.com/#/audit/filing"
            //             style={{
            //               color: "#aa1010",
            //               textDecoration: "none",
            //               fontWeight: "bold",
            //             }}
            //           >
            //             Click here to view
            //           </a>
            //         </>
            //       ),
            //       severity: "error",
            //       autoHide: false,
            //     });
            //   } else if (
            //     filingAuditResponse &&
            //     filingAuditResponse.rl16_filling &&
            //     filingAuditResponse.rl16_filling.length > 0
            //   ) {
            //  
            //     setSnackbarData({
            //       open: true,
            //       message: (
            //         <>
            //           Please load Audit in the menu and clear all audit items
            //           (Audit Filing and PIER Review) to generate documents.{" "}
            //           <a
            //             href="https://appv3.taxslips.com/#/audit/filing"
            //             style={{
            //               color: "#aa1010",
            //               textDecoration: "none",
            //               fontWeight: "bold",
            //             }}
            //           >
            //             Click here to view
            //           </a>
            //         </>
            //       ),
            //       severity: "error",
            //       autoHide: false,
            //     });
            //   } else {
            //     setIsLoadingData(true);
            if (rl16SlipIds && rl16SlipIds.generalAuditStatus !== null && rl16SlipIds.generalAuditStatus === true &&
              rl16SlipIds && rl16SlipIds.auditStatus !== null && rl16SlipIds.auditStatus === true) {
              setIsLoadingData(true);
              try {
                const response: any =
                  await PrintingService.createRL16SummaryPdfPrint(
                    clientId,
                    400,
                    taxYear,
                    event === "Print PDF (English)"
                      ? "rl16-english"
                      : "rl16-french"
                  );
                if (response.status === 400) {
                  setSnackbarData({
                    open: true,
                    message: response.data.message
                      ? response.data.message
                      : "Something went wrong.",
                    // message: "Please Unmask sensitive data for PDF printing.",
                    severity: "error",
                  });
                } else {
                  const filename = `RL16Summary-${clientName}-${event === "Print PDF (English)" ? "English" : "French"
                    }.pdf`;
                  savePdfAsFile(response, filename);
                }
                setIsLoadingData(false);
              } catch (err) {

                alert(err);
              }
              // }
              setIsLoadingData(false);
            } else {
              setIsLoadingData(false);
              setSnackbarData({
                open: true,
                message: (
                  <>
                    Please load Audit in the menu, press Run RL-16 Audit and clear all audit items to generate documents.{" "}
                    <a
                      href="https://appv3.taxslips.com/#/audit/filing"
                      style={{
                        color: "#aa1010",
                        textDecoration: "none",
                        fontWeight: "bold",
                      }}
                    >
                      Click here to view
                    </a>
                  </>
                ),
                severity: "error",
                autoHide: false,
              });
            }
            // } catch (err: any) {
            //   setIsLoadingData(false);
            //   alert(err);
            // }
          } else if (response && response.id !== null) {
            setInvoiceData([response]);
            setInvoiceDialogOpen(true);
          } else {
            setSnackbarData({
              open: true,
              message: "Something went wrong.",
              severity: "error",
            });
          }
          setIsLoadingData(false);
        } catch (err) {

          setIsLoadingData(false);
        }
      }
    }
  };

  const onDeleteClicked = async (): Promise<void> => {
    //delete confirmation code
    try {
      setIsLoadingData(true);
      const response: any =
        await RL16SlipService.RL16SummaryclearConfirmationCode(
          clientId,
          checkSummaryType(RL16SummaryData && RL16SummaryData.slipType),
          taxYear
        );
      ;
      if (response.status === 200) {
        setSnackbarData({
          open: true,
          message: response.data.message,
          severity: "success",
        });
        refetchSlipType()
        dispatch(setSelectedDashboardApisData({ rl16_summary: { confirmationCode: null } }));
      } else {
        setSnackbarData({
          open: true,
          message:
            response &&
              response.message !== undefined &&
              typeof (response.message && response.message) !== "object"
              ? response.message && response.message
              : response.message.message
                ? response.message.message
                : "Something went wrong!",
          severity:
            response.status === false
              ? "error"
              : response.success === false
                ? "error"
                : "success",
        });
      }
      setIsLoadingData(false);
    } catch (err) {
      setIsLoadingData(false);

    }
  };

  /**
   * On Snackbar closed.
   *
   * @param {React.SyntheticEvent | Event} event
   * @param {string} reason
   */
  const onSnackbarClosed = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarData(INITIAL_SNACKBAR_DATA);
  };

  useEffect(() => {

    // if the selected flex field data has loaded.
    if (RL16SummaryData) {
      Object.keys(RL16SummaryData).forEach((fieldName) => {
        // @ts-ignore
        const fieldValue = RL16SummaryData[fieldName];
        // @ts-ignore
        formMethods.setValue(fieldName, fieldValue ?? undefined);
        // if (fieldValue && fieldValue !== null) {
        //   formMethods.setValue(fieldName, parseFloat(fieldValue).toFixed(2))
        // } else {
        //   formMethods.setValue(fieldName, "0.00");
        // }
        //set all values to desimal
        // if(fieldName === "totalNumberOfRL16SlipsFiled"){ fieldValue !== null || undefined ? formMethods.setValue(fieldName, parseFloat(fieldValue).toFixed(2)) : formMethods.setValue(fieldName,"0.00") }

        if (fieldName === "capitalGains") {
          fieldValue !== null || undefined
            ? formMethods.setValue(fieldName, parseFloat(fieldValue).toFixed(2))
            : formMethods.setValue(fieldName, "0.00");
        }
        if (fieldName === "singlePensionPayment") {
          fieldValue !== null || undefined
            ? formMethods.setValue(fieldName, parseFloat(fieldValue).toFixed(2))
            : formMethods.setValue(fieldName, "0.00");
        }
        if (fieldName === "actualAmountOfEligibleDividends") {
          fieldValue !== null || undefined
            ? formMethods.setValue(fieldName, parseFloat(fieldValue).toFixed(2))
            : formMethods.setValue(fieldName, "0.00");
        }
        if (fieldName === "actualAmountOfOrdinaryDividends") {
          fieldValue !== null || undefined
            ? formMethods.setValue(fieldName, parseFloat(fieldValue).toFixed(2))
            : formMethods.setValue(fieldName, "0.00");
        }
        if (fieldName === "pensionPaymentGivingEntitlement") {
          fieldValue !== null || undefined
            ? formMethods.setValue(fieldName, parseFloat(fieldValue).toFixed(2))
            : formMethods.setValue(fieldName, "0.00");
        }
        if (fieldName === "foreignBusinessIncome") {
          fieldValue !== null || undefined
            ? formMethods.setValue(fieldName, parseFloat(fieldValue).toFixed(2))
            : formMethods.setValue(fieldName, "0.00");
        }
        if (fieldName === "foreignNonBusinessIncome") {
          fieldValue !== null || undefined
            ? formMethods.setValue(fieldName, parseFloat(fieldValue).toFixed(2))
            : formMethods.setValue(fieldName, "0.00");
        }
        if (fieldName === "otherIncome") {
          fieldValue !== null || undefined
            ? formMethods.setValue(fieldName, parseFloat(fieldValue).toFixed(2))
            : formMethods.setValue(fieldName, "0.00");
        }
        if (fieldName === "capitalGainsGivingEntitlement") {
          fieldValue !== null || undefined
            ? formMethods.setValue(fieldName, parseFloat(fieldValue).toFixed(2))
            : formMethods.setValue(fieldName, "0.00");
        }
        if (fieldName === "taxableAmountOfEligibleAndOrdinaryDividends") {
          fieldValue !== null || undefined
            ? formMethods.setValue(fieldName, parseFloat(fieldValue).toFixed(2))
            : formMethods.setValue(fieldName, "0.00");
        }
        if (fieldName === "dividendTaxCredit") {
          fieldValue !== null || undefined
            ? formMethods.setValue(fieldName, parseFloat(fieldValue).toFixed(2))
            : formMethods.setValue(fieldName, "0.00");
        }
        if (fieldName === "foreignIncomeTaxOnNonBusinessIncome") {
          fieldValue !== null || undefined
            ? formMethods.setValue(fieldName, parseFloat(fieldValue).toFixed(2))
            : formMethods.setValue(fieldName, "0.00");
        }
        if (fieldName === "costBaseAdjustmentOfCapitalInterest") {
          fieldValue !== null || undefined
            ? formMethods.setValue(fieldName, parseFloat(fieldValue).toFixed(2))
            : formMethods.setValue(fieldName, "0.00");
        }
      });
    }
  }, [RL16SummaryData, formMethods.setValue, formMethods]);

  const onUnPaidClickHandler = (clickedRow: any, tag: string) => {
    setIsLoadingData(true);
    // setTimeout(() => {
    //   setIsLoadingData(false);
    // }, 2500);
    const fetchData = async () => {
      try {
        const response: any =
          await ReportsService.paypalIntegrationOfUnpaidInvoice(
            clientId,
            clickedRow.refNo,
            tag
          );
        setIsLoadingData(false);

        if (tag === 'paypal') {
          window.open(response, '_blank');
        } else {
          window.open(response.message, '_blank');
        }
      } catch (error) {
        setIsLoadingData(false);
        console.error("Error fetching data:", error);
      } finally {
        setIsLoadingData(false);
      }
    }
    fetchData();

  };

  const onClickInvoiceNoHandler = (clickedRow: any) => {
    dispatch(setSelectedINVOICE(clickedRow));

  };

  useEffect(() => {
    dispatch(
      setSelectedActivityLogActions({
        entityId1: "",
        entityId2: "",
        entityId3: "",
        screenName: RL16_SUMMARY_SCREEN_SLUG,
        companyName: clientName,
        activityType:
          "activity_type=updated&activity_type=delete&activity_type=print&activity_type=print_xml",
        activityLogVisibility: true,
      })
    );
    dispatch(setSelectedStickyNavBar({ isSticky: true }));
  }, []);

  return (
    <Grid
      size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
      sx={{ "& .MuiAppBar-root": { zIndex: 2, top: "65px" } }}
    >
      <BackdropCircularProgress
        open={
          // isLoadingSelectedFlexField ||
          isSubmitting ||
          isLoadingSummaryGetData ||
          reFetchingSlipType ||
          isLoadingGlobalVariables ||
          // isLoadingselectedSlipType
          isLoadingData ||
          isLoadingActivityLogData
        }
        testId={testId}
      />
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(onSubmit)}>
          <SingleColumnLayout
            toolbar={
              <RL16SummaryToolbar
                isSubmitting={isSubmitting}
                // onGenerateXMLClicked={onGenerateXMLClicked}
                onPrintClicked={onPrintClicked}
                onDeleteClicked={onDeleteClicked}
              />
            }
            testId="t4-slip-summary-setup-form"
          >
            <Paper>
              <FlatStandardPanel
                title="Account Information"
                testId={`${testId}-account-information-panel`}
                showTitle={false}
                topPadding={3}
                leftSpacing={2}
                rightSpacing={2}
              >
                <TaxSlipAccountInformation
                  logoURL={`${import.meta.env.BASE_URL !== "/" ? import.meta.env.BASE_URL : ""}/images/cra_logo.png`}
                  accountIdentifierTitle="Payer's account number"
                  accountIdentifier="121212120RP0001"
                  accountInformationMessage="You have to file your RL-16 information return on or before the last day of February."
                  accountName="HELLOFRESH"
                  accountAddressLine1="House # 34, Street twenty three Link Road Cavalary Ground"
                  accountCity=" Toronto"
                  accountProvince="ON"
                  accountPostalCode="W3R4RL16"
                  companyInformation={RL16SummaryData && RL16SummaryData}
                />
              </FlatStandardPanel>
              <Divider
                component="hr"
                sx={{ width: "68%", marginLeft: "16%", marginRight: "16%" }}
              />
              <FlatStandardPanel
                title="RL-16 Slips Detail"
                testId={`${testId}-t4-slip-detial-panel`}
                leftSpacing={2}
                rightSpacing={2}
              >
                <RL16SlipDetailPanel
                  formMethods={formMethods}
                  globalVariablesData={
                    globalVariablesData && globalVariablesData
                  }
                />
              </FlatStandardPanel>
              <Spacer y={4} x={4} />
            </Paper>
          </SingleColumnLayout>
        </form>
      </FormProvider>
      {/* invoice dialogu open if any transaction is unPaid */}
      <EnhancedDialog
        dialogTitle="Invoice(s) Due"
        key="dialog-box"
        testId="dialog"
        onCloseHandler={onCloseHandler}
        open={openInvoiceDialog}
        dialogContent={
          <InvoiceDialogPanel
            invoiceData={invoiceData}
            onUnPaidClickHandler={onUnPaidClickHandler}
            onClickInvoiceNoHandler={onClickInvoiceNoHandler}
          />
        }
        dialogAction={
          <Grid>
            <Button autoFocus variant="contained" onClick={onCloseHandler}>
              Cancel
            </Button>
          </Grid>
        }
      />
      <EnhancedSnackbar
        message={snackbarData.message}
        onCloseHandler={onSnackbarClosed}
        severity={snackbarData.severity}
        testId={`${testId}-snackbar`}
        open={snackbarData.open}
        autoHide={snackbarData.autoHide}
      />
    </Grid>
  );
};
